import { FGStack, FGTile, FGTypography, FGIcons } from "@fg/design-system";
import { IActiveDimension, IAPIActiveClientFacingIndicator } from "interfaces";
import { isEmpty, map } from "lodash/fp";
import { inject } from "mobx-react";
import { getCFILongName, getDimensionLongName } from "utils/riskUtils";
import rootStore, { IMobxRootState } from '../../RootStore';

const MAX_VISIBLE_RISKS = 5;

type MultiRiskPickerPreviewProps = {
    dimensions?: { [dimensionId: number]: IActiveDimension };
    activeClientFacingIndicators?: IAPIActiveClientFacingIndicator;
    isClientFacingIndicators?: boolean;
    activeDimList?: number[];
};

//todo: rename to MultiRiskPickerLabel
export const MultiRiskPickerPreview = inject(
    ({ risksStore }: IMobxRootState) => {
        return {
            dimensions: risksStore.dimensions.hashed,
            activeClientFacingIndicators: risksStore.clientFacingIndicators,
            isClientFacingIndicators: risksStore.isClientFacingIndicators,
            activeDimList: risksStore.currentList,
        };
    }
)((props: MultiRiskPickerPreviewProps) => {
    const {
        dimensions,
        activeClientFacingIndicators,
        isClientFacingIndicators,
        activeDimList,
    } = props;

    const visibleRisks = activeDimList.slice(0, MAX_VISIBLE_RISKS);
    const overflowRisks = activeDimList.slice(MAX_VISIBLE_RISKS);

    return (
        <FGStack
            direction="row"
            alignItems="center"
            gap={4}
            style={{ flexWrap: 'wrap' }}>
            {map((risk: number) => {
                return (
                    <FGTile
                        padding="small"
                        appearance="primary"
                        key={risk}
                        onClick={(e: React.MouseEvent) => {
                            e.stopPropagation();
                            rootStore.risksStore.toggleRisk(risk);
                        }}
                        style={{ width: 'auto' }}>
                        <FGStack alignItems="center" gap={8}>
                            <FGTypography
                                tag="label"
                                variant="label3"
                                cssStyle={{
                                    whiteSpace: 'nowrap',
                                    pointerEvents: 'none',
                                }}>
                                {isClientFacingIndicators
                                    ? getCFILongName(
                                          activeClientFacingIndicators[risk]
                                      )
                                    : getDimensionLongName(dimensions[risk])}
                            </FGTypography>
                            <FGIcons icon="Close" />
                        </FGStack>
                    </FGTile>
                );
            }, visibleRisks)}
            {!isEmpty(overflowRisks) && (
                <FGTile
                    padding="small"
                    appearance="primary"
                    onClick={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        // todo: refactor both risksStore.toggleRisk and KeyValueStore.toggleValue to
                        // accept an array of values instead of spread args, or add a toggleRisks/toggleValues methods.
                        rootStore.risksStore.toggleRisk(
                            overflowRisks[0],
                            ...overflowRisks.slice(1)
                        );
                    }}
                    style={{ width: 'auto' }}>
                    <FGStack alignItems="center" gap={8}>
                        <FGTypography
                            tag="label"
                            variant="label3"
                            cssStyle={{
                                whiteSpace: 'nowrap',
                                pointerEvents: 'none',
                            }}>
                            {`+${overflowRisks.length}`}
                        </FGTypography>
                        <FGIcons icon="Close" />
                    </FGStack>
                </FGTile>
            )}
        </FGStack>
    );
});

export const MultiRiskPickerClearButton = () => (
    <FGIcons
        icon="Remove"
        aria-label="Reset to default risk"
        style={{ cursor: 'pointer' }}
        onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            rootStore.risksStore.resetRisksToDefault();
        }}
    />
);
